<template>
  <button class="mt-4 appRegularButton" @click="this.$router.push('/mill')">Back</button>
  <h1>Deleted booking mill page</h1>
</template>
